var _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedExclamation(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 16,
    fill: "#FFBABA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.5C19.825 11.5 20.5 12.175 20.5 13V19C20.5 19.825 19.825 20.5 19 20.5C18.175 20.5 17.5 19.825 17.5 19V13C17.5 12.175 18.175 11.5 19 11.5ZM18.985 4C10.705 4 4 10.72 4 19C4 27.28 10.705 34 18.985 34C27.28 34 34 27.28 34 19C34 10.72 27.28 4 18.985 4ZM19 31C12.37 31 7 25.63 7 19C7 12.37 12.37 7 19 7C25.63 7 31 12.37 31 19C31 25.63 25.63 31 19 31ZM20.5 26.5H17.5V23.5H20.5V26.5Z",
    fill: "#3F3F3F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExclamation);
export default __webpack_public_path__ + "static/media/RedExclamation.19b12152bff9fd9f0c893aaeec1e3e12.svg";
export { ForwardRef as ReactComponent };